import { render } from "./CustomersFeedback.vue?vue&type=template&id=4c1586ee&scoped=true&ts=true"
import script from "./CustomersFeedback.vue?vue&type=script&lang=ts"
export * from "./CustomersFeedback.vue?vue&type=script&lang=ts"

import "./CustomersFeedback.vue?vue&type=style&index=0&id=4c1586ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1586ee"]])

export default __exports__